import axios from "axios";

export default function postConfigProductOrderrow(
  env,
  sessionId,
  apiKey,
  body,
  onSuccess,
  onError
) {
  const { protocol } = window.location;
  const baseUrl =
    env === "test"
      ? `${protocol}//webshop-testapi.skbygg.com`
      : "https://webshop-api.skbygg.com";
  const url = `${baseUrl}/webshop/jeeves/configProductOrderrow/${sessionId}`;
  const headers = {
    Authorization: "Basic",
    ApiKey: apiKey,
    "Content-Type": "application/json",
  };

  axios
    .post(url, body, { headers })
    .then(response => {
      const { status } = response;
      if (status === 200 || status === 201 || status === 202) {
        onSuccess();
      } else {
        onError(
          "Error, unexpected response status in postConfigProductOrderrow"
        );
      }
    })
    .catch(error => {
      onError(JSON.stringify(error));
    });
}
